import "react-intl-tel-input/dist/main.css"
import "./InviteWithPhone.scss"

import { Button, PhoneInput, TextTag as Text } from "../../atoms"
import {
  EMPTY_PHONE_NUMBER,
  INVALID_FLAG_SELECTED,
  INVALID_MOBILE,
  INVITE_BUTTON,
  INVITE_FOOTER_TEXT,
  NICKNAME_REQUIRED,
  CONTACT_YOU_PHONE_LABEL,
  PHONE_NUMBER_REQUIRED,
  INVITE_MOBILE_LABEL,
} from "../../constants/messages"
import _ from "../../utils/lodashUtils"
import { Form } from "antd"
import { INVITE_FAILURE } from "../../constants/notificationMsg"
import { ActivityIndicator } from "../../components/ActivityIndicator"
import React from "react"

const FormItem = Form.Item

const InviteWithPhone = (props) => {
  const {
    nickName,
    setNickNameError,
    isInvited,
    invite,
    onConfirmButtonClick,
    isDisabled,
    inviteOperationLoading,
  } = props

  const [phoneNumber, setPhoneNumber] = React.useState(
    props.inviteeMobile ? props.inviteeMobile : ""
  )
  const [phoneError, setPhoneError] = React.useState("")
  const [invitedNumber, setInvitedNumber] = React.useState()
  const [errorMsg, setErrorMsg] = React.useState("")

  const reg = new RegExp("[-() ]", "g")

  const handleValidation = (e) => {
    e.preventDefault()
    if (!nickName) {
      setNickNameError(NICKNAME_REQUIRED)
      if (!phoneNumber) handleSubmit()
      return
    } else {
      setNickNameError("")
    }
    if (phoneError) {
      return
    }
    handleSubmit()
  }

  const handleSubmit = () => {
    if (phoneNumber) {
      invite("PHONE", { inviteeMobile: phoneNumber }, nickName).then(
        (success) => { })
        .catch((err) => {
          setInvitedNumber(phoneNumber)
        })
    } else {
      setPhoneError(true)
      setErrorMsg(EMPTY_PHONE_NUMBER)
    }
  }

  return (
    <div id="inviteWithPhone" className="invite-with-phone">
      <form name="invite_phone" onSubmit={handleValidation}>
        <div id="detailsRow">
          <div>
            <FormItem>
              <div className="phone-input-wrapper">
                <Text className="invite-label">{INVITE_MOBILE_LABEL}</Text>
                <div className="telephone">
                  <PhoneInput
                    inputClassName="form-control"
                    format={true}
                    defaultValue={phoneNumber}
                    separateDialCode={true}
                    numberType={"MOBILE"}
                    disabled={props.isDisabled || isInvited}
                    placeholder={CONTACT_YOU_PHONE_LABEL}
                    onPhoneNumberBlur={(isPhoneValid, number) => {
                      if (!isPhoneValid && !number) {
                        setPhoneError(true)
                        setErrorMsg(PHONE_NUMBER_REQUIRED)
                      }
                    }}
                    onPhoneNumberChange={(
                      isValid,
                      number,
                      data,
                      formattedValue
                    ) => {
                      if (isValid) {
                        let phoneNumber = formattedValue.replace(reg, "")
                        setPhoneNumber(phoneNumber)
                        setPhoneError(!isValid)
                      } else {
                        setPhoneError(!isValid)
                        setErrorMsg(INVALID_MOBILE)
                      }
                    }}
                    onSelectFlag={(number, obj, formattedValue, isWrong) => {
                      if (number !== "" && !isWrong) {
                        setPhoneError(!isWrong)
                        setErrorMsg(INVALID_FLAG_SELECTED)
                      } else {
                        setErrorMsg("")
                      }
                    }}
                    error={phoneError && errorMsg}
                  />
                </div>
              </div>
              {phoneNumber &&
              phoneNumber === invitedNumber &&
              isInvited !== null &&
              !isInvited &&
              !phoneError ? (
                <div className="label-error">{INVITE_FAILURE("phone")}</div>
              ) : null}
            </FormItem>
            <div className="phoneInput"></div>
          </div>
        </div>
        <div className="footer-btn-box">
          <Form.Item>
            <Button
              btnSize="large"
              btnType="primary"
              htmlType="submit"
              className="login-form-button"
              disabled={
                props.isDisabled ||
                Boolean(phoneError) ||
                inviteOperationLoading
              }
            >
              {inviteOperationLoading && <ActivityIndicator />}
              {INVITE_BUTTON(nickName)}
            </Button>
          </Form.Item>
        </div>
      </form>
    </div>
  )
}

export default InviteWithPhone
